import React, {useEffect, useState} from "react";
import InfoOnline from "../../components/InfoOnline";
import {ItemInfoSpouse} from "../../components/ViewData";
import NoRecords from "../../components/NoRecords";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import {useTranslation} from "react-i18next";
import {InformationSriInterface} from "../../../services/interface/sri/information-sri-interface";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import {useFindAdditionalInformation} from "../../../services/apis/apiRuc";

export default function AdditionalInformation() {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: getTaxPayer,
        data: successTaxPayer,
        isPending: loadingTaxPayer,
        error: errorTaxPayer,
    } = useFindAdditionalInformation()

    const [response, setResponse] = useState<InformationSriInterface | undefined>()

    useEffect(() => {
        if (person?.accountant || person?.taxIdentificationNumber) {
            getTaxPayer({
                identifier: `${person?.taxIdentificationNumber ? person.taxIdentificationNumber : person?.accountant}`,
                msj: t('ruc')
            })
        }
    }, [person]);

    useEffect(() => {
        if (successTaxPayer) {
            setResponse(successTaxPayer);
        }
    }, [successTaxPayer]);

    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('additional-information')}</h3>
                <InfoOnline
                    onClick={() => {
                        getTaxPayer({
                            identifier: `${person?.taxIdentificationNumber ? person.taxIdentificationNumber : person?.accountant}`,
                            msj: t('ruc')
                        })
                    }}
                />
            </div>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/tax_payer/basicData'}
                loading={loadingTaxPayer}
                error={errorTaxPayer}
                component={
                    <>
                        {response ?
                            <div className={'custom-card px-3 py-3 flex flex-col gap-3'}>
                                <div className={'grid grid-cols-1 md:grid-cols-2 gap-3'}>
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-1')}
                                        text={
                                            response?.isStateGoodsOrServicesSupplier === undefined || response?.isStateGoodsOrServicesSupplier === null ? '-' :
                                                response?.isStateGoodsOrServicesSupplier ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-2')}
                                        text={
                                            response?.isAMV === undefined || response?.isAMV === null ? '-' :
                                                response?.isAMV ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-3')}
                                        text={response?.yearSinceBICCompany}
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-4')}
                                        text={response?.judicialRulingAffectingCompany}
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-5')}
                                        text={
                                            response?.offersPaymentRemittanceServices === undefined || response?.offersPaymentRemittanceServices === null ? '-' :
                                                response?.offersPaymentRemittanceServices ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-6')}
                                        text={
                                            response?.isPublicInterestCompany === undefined || response?.isPublicInterestCompany === null ? '-' :
                                                response?.isPublicInterestCompany ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-7')}
                                        text={
                                            response?.impactAreasBIC === undefined || response?.impactAreasBIC === null ? '-' :
                                                response?.impactAreasBIC ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-8')}
                                        text={response?.lastCorporateUpdateDate}
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-9')}
                                        text={
                                            response?.isCompanySellsOnCredit === undefined || response?.isCompanySellsOnCredit === null ? '-' :
                                                response?.isCompanySellsOnCredit ? t('SI') : t('NO')
                                        }
                                    />
                                    <ItemInfoSpouse
                                        label={t('additional-information-detail-10')}
                                        text={
                                            response?.isBICCompany === undefined || response?.isBICCompany === null ? '-' :
                                                response?.isBICCompany ? t('SI') : t('NO')
                                        }
                                    />
                                </div>
                            </div>
                            : <NoRecords/>
                        }
                    </>
                }
            />
        </div>
    )
}
